import React from "react";
import EmptyState from "../../../shared/ui/EmptyState";
import MedicationCard from "./MedicationCard";

export default function MedicationList({ medications = [], onViewDetail }) {
  if (!Array.isArray(medications) || medications.length === 0) {
    return (
      <div className="glass-card rounded-3xl p-6 text-center">
        <EmptyState
          title="Nenhuma medicação cadastrada"
          description="Quando você cadastrar uma medicação, ela aparecerá aqui com seu estoque e horários."
          variant="soft"
        />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
      {medications.map((medication, index) => {
        const key = medication?.id ?? `${medication?.name}-${index}`;

        return (
          <MedicationCard
            key={key}
            name={medication?.name}
            status={medication?.status}
            medicationType={medication?.medicationType}
            availableTotalLabel={medication?.availableTotalLabel}
            secondaryLabel={medication?.secondaryLabel}
            onViewDetail={() => {
              if (onViewDetail) onViewDetail(medication);
            }}
          />
        );
      })}
    </div>
  );
}